import {
  MyCustomerDataResponseDto
} from '@features/customer/application/use_cases/my-customer-data/dto/my-customer-data.response.dto';
import {
  MyCustomerDataPayloadDto
} from '@features/customer/application/use_cases/my-customer-data/dto/my-customer-data.payload.dto';

import {
  MyCustomerDataHttpDto,
  MyCustomerDataHttpResponseDto
} from '@features/customer/infrastructure/http/my-customer-data/my-customer-data.http.response.dto';
import {
  MyCustomerDataHttpPayloadDto
} from '@features/customer/infrastructure/http/my-customer-data/my-customer-data.http.payload.dto';
import {CustomerEntity} from '@features/customer/domain/entities/customer.entity';
import {CustomerPersonTypeEnum} from '@features/customer/domain/enums/customer-person-type.enum';
import {
  CustomerValidationStatusTypeEnum
} from '@features/customer/domain/enums/customer-validation-status-type.enum';

export class MyCustomerDataHttpMapper {

  static toResponse(data: MyCustomerDataHttpResponseDto): MyCustomerDataResponseDto {
    return {
      customer: data.data.length === 0
        ? null
        : MyCustomerDataHttpMapper.mapCustomer(data.data[0])
    }
  }

  static toInfra(data: MyCustomerDataPayloadDto): MyCustomerDataHttpPayloadDto {
    return {}
  }

  static mapCustomer(data: MyCustomerDataHttpDto): CustomerEntity {
    const now = new Date().toISOString();
    return CustomerEntity.fromPrimitives({
      id: data.id.toString(),
      agreement_id: data.agreement_id != null ? data.agreement_id.toString() : null,
      users_phone_number: data.users_phone_number,
      person_type_code: data.person_type_code as CustomerPersonTypeEnum,
      document_type_code: data.document_type_code,
      document_number: data.document_number,
      document_type_code_legal: data.document_type_code_legal,
      document_number_legal: data.document_number_legal,
      business_name: data.business_name,
      business_commercial_name: data.business_commercial_name,
      first_name: data.first_name,
      other_name: data.other_name ?? '',
      first_surname: data.first_surname,
      second_surname: data.second_surname ?? '',
      birth_date: data.birth_date,
      expedition_date: data.expedition_date,
      expedition_country: data.expedition_country,
      expedition_state: data.expedition_state,
      expedition_city: data.expedition_city,
      image_front_document: data.image_front_document,
      image_front_document_ext: data.image_front_document_ext,
      image_back_document: data.image_back_document,
      image_back_document_ext: data.image_back_document_ext,
      selfie_user: data.selfie_user,
      selfie_user_ext: data.selfie_user_ext,
      document_validate: data.document_validate == 1,
      biometric_2d_validate: data.biometric_2d_validate == 1,
      biometric_3d_validate: data.biometric_3d_validate == 1,
      police_validate: data.police_validate as CustomerValidationStatusTypeEnum,
      comptroller_validate: data.comptroller_validate as CustomerValidationStatusTypeEnum,
      prosecutor_validate: data.prosecutor_validate as CustomerValidationStatusTypeEnum,
      image_police_validate: data.image_police_validate,
      image_comptroller_validate: data.image_comptroller_validate,
      image_prosecutor_validate: data.image_prosecutor_validate,
      // Campos no presentes en este endpoint: valores por defecto.
      addresses_id: '',
      status_identity_document: CustomerValidationStatusTypeEnum.PENDING,
      status_identity_document_back: CustomerValidationStatusTypeEnum.PENDING,
      status_labor_certificate: CustomerValidationStatusTypeEnum.PENDING,
      status_payroll_receipt: CustomerValidationStatusTypeEnum.PENDING,
      status_bank_certificate: CustomerValidationStatusTypeEnum.PENDING,
      identity_document: null,
      identity_document_back: null,
      labor_certificate: null,
      payroll_receipt: null,
      bank_certificate: null,
      income: Number(data.income),
      expenses: Number(data.expenses),
      legal_validation_notification: false,
      is_exits_pre_approved: false,
      createdAt: now,
      updatedAt: now,
    });
  }

}
